import { Component } from '@angular/core';
import { GlobalService } from 'src/app/services/helper/global-helper';

@Component({
  selector: 'app-visualizations-list-multi',
  templateUrl: './visualizations-list-multi.component.html',
  styleUrls: ['./visualizations-list-multi.component.scss']
})
export class VisualizationsListMultiComponent {

  public machinenumber: string = "";
  imgExist: boolean = true;
  
    constructor(private global: GlobalService){
      this.global.machineNumber.subscribe({
        next: newValue => {this.machinenumber = newValue.number;}
      });
    }

    updateImg() {
      this.imgExist = false;
    }

}
